<template>
	<div class="container-fuild">
		<div class="card card-shape home-box">
			<div
				class="card-header d-flex flex-row align-items-center justify-content-between">
				<h6 class="m-0 fw-bold text-green">Bulk Journal Import</h6>
				<div class="d-flex">
					<b-link
						title="Download Excel Format"
						@click="downloadFile"
						class="fw-semibold ms-2 akkurate-green">
						<font-awesome-icon :icon="['fas', 'download']" />
					</b-link>
					<b-link
						@click="$bvModal.show('add-excel-id')"
						title="Import Refs"
						class="fw-semibold ms-2 akkurate-green">
						<font-awesome-icon :icon="['fas', 'filter']" />
					</b-link>
				</div>
				<b-modal id="add-excel-id" ref="modal" size="md" @ok="handleOk">
					<template #modal-title>
						<h6 class="m-0 fw-bold text-green text-sm">
							Excel References
						</h6>
					</template>
					<div class="row">
						<div class="col-12">
							<b-form-group
								label-for="excel_upload_ref"
								class="mb-2">
								<template #label>
									<label
										class="akkurate-dark small"
										for="surname"
										>Excel Upload References <star> </star>
									</label>
								</template>
								<b-form-input
									id="excel_upload_ref"
									v-model="retrive_form.excel_upload_ref"
									name="excel_upload_ref"
									class="mt-1 field-container fields"
									type="text"
									required></b-form-input>
							</b-form-group>
						</div>
					</div>
					<template #modal-footer="{ ok }">
						<b-button
							@click="ok()"
							type="submit"
							class="btn akkurate-green-btn btn-size text-white me-2">
							<span class="akkurate-small"
								><font-awesome-icon :icon="['fas', 'plus']" />
								Retrive</span
							></b-button
						>
						<b-button
							@click="$bvModal.hide('add-excel-id')"
							class="btn akkurate-gray-btn btn-size text-white">
							<span class="akkurate-small"
								><font-awesome-icon :icon="['fas', 'close']" />
								Close</span
							></b-button
						>
					</template>
				</b-modal>
			</div>
			<div class="card-body">
				<div class="err-accounts text-center my-2">
					<errors v-if="message">
						{{ message }}
					</errors>
				</div>
				<div
					class="card card-shape home-box mb-3 border border-success">
					<div class="card-body py-2">
						<div class="row mb-3">
							<div class="col-md-9">
								<div class="row">
									<div class="col">
										<label
											class="akkurate-dark small"
											for="phone"
											>Choose File<star> </star
										></label>
										<input
											type="file"
											class="form-control mt-2"
											@change="handleFileUpload"
											ref="fileInput"
											accept=".xlsx,.xls" />
									</div>
									<div class="col-3">
										<label
											class="akkurate-dark small"
											for="excel_upload_ref"
											>Excel Upload Ref:<star> </star
										></label>
										<b-form-group
											id="excel_upload_ref"
											label-for="excel_upload_ref"
											class="akkurate-dark">
											<b-form-input
												id="excel_upload_ref"
												class="mt-2 field-container fields"
												type="text"
												v-model="form.excel_upload_ref"
												placeholder="Enter Excel Upload Ref">
											</b-form-input>
										</b-form-group>
									</div>
									<div class="col-2 mt-auto">
										<label
											class="akkurate-dark small"
											for="total_count"
											>Total Debit</label
										>
										<div class="mt-2">
											{{ total_debit }}
										</div>
									</div>
									<div class="col-2 mt-auto">
										<label
											class="akkurate-dark small"
											for="total_a"
											>Total Credit</label
										>
										<div class="mt-2">
											{{ total_credit }}
										</div>
									</div>
									<div class="col-2 mt-auto">
										<label
											class="akkurate-dark small"
											for="total_a"
											>Difference</label
										>
										<div class="mt-2">
											{{ total_debit - total_credit }}
										</div>
									</div>
								</div>
							</div>
							<div class="col mt-auto">
								<b-button
									:disabled="isSaving"
									class="btn-size w-75 akkurate-green-btn"
									@click="saveBulkJournal"
									><font-awesome-icon
										class="small"
										:icon="['fas', 'upload']" />
									Import</b-button
								>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<vue-good-table
							styleClass="vgt-table bordered striped"
							mode="remote"
							ref="allAccountTable"
							:columns="account_columns"
							:rows="account_rows"
							:isLoading.sync="isLoading"
							:totalRows="totalRecords"
							:select-options="{
								enabled: true,
								disableSelectInfo: true, // disable the select info panel on top
							}">
						</vue-good-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import SidebarView from "@/views/main/components/Sidebar.vue";
	import TopbarView from "@/views/main/components/Topbar.vue";
	import Footer from "@/views/main/components/Footer.vue";
	import * as XLSX from "xlsx";
	import config from "@/config";
	import ApiService from "@/core/services/api.service";

	export default {
		components: {
			SidebarView,
			TopbarView,
			Footer,
		},
		data() {
			return {
				...this.initialState(),
				account_rows: [],
				account_columns: [
					{
						label: "GL Code",
						field: "gl_code",
					},
					{
						label: "DrAmount",
						field: "debit",
					},
					{
						label: "CrAmount",
						field: "credit",
					},
					{
						label: "Narration",
						field: "narration",
					},
					{
						label: "Recorded Date",
						field: "recorded_date",
					},
				],
				message: "",
				excel_upload_id: "",
				rows: [],
			};
		},
		methods: {
			downloadFile() {
				// Replace 'example.pdf' with the filename you want to download from your public directory
				const fileName = "JOURNAL_TEMPLATE.xlsx";

				// console.log(fileName);

				// Construct the URL to the file in the public directory
				const fileUrl = `${config.base_url}/assets/${fileName}`;

				//   console.log(fileUrl);

				// Create a link element
				const link = document.createElement("a");
				link.href = fileUrl;
				link.download = fileName;

				// Append the link to the body
				document.body.appendChild(link);

				// Programmatically click the link to trigger the download
				link.click();

				// Remove the link from the body
				document.body.removeChild(link);
			},
			handleFileUpload(event) {
				this.excelFile = event.target.files[0];
				if (this.excelFile) {
					const reader = new FileReader();
					reader.onload = (e) => {
						const data = new Uint8Array(e.target.result);
						const workbook = XLSX.read(data, { type: "array" });
						const sheetName = workbook.SheetNames[0];
						const sheet = workbook.Sheets[sheetName];
						const jsonData = XLSX.utils.sheet_to_json(sheet, {
							header: 1,
						});

						// Convert to JSON
						const headers = jsonData[0];
						const jsonDataArray = [];
						for (let i = 1; i < jsonData.length; i++) {
							const row = jsonData[i];
							const obj = {};
							for (let j = 0; j < headers.length; j++) {
								const key = headers[j]
									.replace(/\s/g, "_")
									.toLowerCase(); // Replace spaces with underscores
								let value = null;
								if (row[j]) {
									value = String(row[j]); // Convert value to string
								}
								obj[key] = value;
							}
							// this.total_amount += Number(obj.commission)
							this.total_debit += Number(obj.debit);
							this.total_credit += Number(obj.credit);
							jsonDataArray.push(obj);
						}
						this.total_count = jsonDataArray.length;

						// Call showExcelUploads with the processed data
						this.showExcelUploads(jsonDataArray);
					};
					reader.readAsArrayBuffer(this.excelFile);
				} else {
					this.showExcelUploads([]); // Handle the case where no file is selected
				}
			},
			async saveBulkJournal() {
				this.isSaving = true;
				const payload = new FormData();
				payload.append("excel_upload_ref", this.form.excel_upload_ref);
				if (this.excelFile) {
					payload.append("excelFileInput", this.excelFile);
				}

				await ApiService.post("/journals/imports/create", payload)
					.then((response) => {
						this.isLoadingSaving = false;
						this.$Progress.finish();
						this.message = "";
						swal.fire({
							icon: "success",
							title: "Success",
							text: response.data.message,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "OK", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});

						this.isSaving = false;
						// this.form.reset();
						this.form = this.initialState().form;
						this.account_rows = [];
						// this.form.gl_debit = "";
					})
					.catch((error) => {
						this.isSaving = false;
						this.$Progress.fail();
						if (error.response.data) {
							this.message = error.response.data.message;
						}
					});
			},
			showExcelUploads(account_rows) {
				// console.log("Received account rows:", account_rows);
				this.account_rows = account_rows;
				// .filter(index => index.entry_date || index.release_date || index.start_date || index.maturity || index.lastdate_payment) // Filter out entries without dates
				// .map(index => ({
				//   ...index,
				//   entry_date: new Date(index.entry_date),
				//   release_date: new Date(index.release_date),
				//   start_date: new Date(index.start_date),
				//   maturity: new Date(index.maturity),
				//   lastdate_payment: new Date(index.lastdate_payment)
				// })); // Map and transform the remaining entries
			},
			handleOk() {},
			initialState() {
				return {
					totalRecords: 0,
					searchFilter: "",
					total_debit: 0,
					total_credit: 0,
					isLoading: true,
					isSaving: false,
					form: {
						excel_upload_ref: "",
					},
					retrive_form: {
						excel_upload_ref: "",
					},
				};
			},
		},
	};
</script>
